export default __webpack_public_path__ + "static/media/223.8aad8784.gif";